import { PopoverContentProps, Tooltip } from '@farol-ds/react'
import { RefObject, useCallback, useEffect, useState } from 'react'

import styles from './motion-tooltip.module.scss'

export type MotionTooltipProps = PopoverContentProps & {
  contentRef: RefObject<HTMLElement>
}

const TOOLTIP_TEXT = 'Informação pessoal ocultada para preservar a parte do processo'
const SELECTOR = '.entity'

export function MotionTooltip(props: MotionTooltipProps) {
  const { contentRef } = props

  const [buttonPosition, setButtonPosition] = useState({ x: 0, y: 0, w: 0 })

  const getElementNodes = useCallback(() => {
    return contentRef.current?.querySelectorAll<HTMLElement>(SELECTOR) ?? []
  }, [contentRef])

  useEffect(() => {
    function handleButtonPosition(targetElement: HTMLElement) {
      const { x, width: w, y: elementY } = targetElement.getBoundingClientRect()
      const y = elementY + window.scrollY
      setButtonPosition({ x, y, w })
    }

    function handleMouseEnter(event: Event) {
      if (event instanceof MouseEvent && event.target instanceof HTMLElement) {
        handleButtonPosition(event.target)
      }
    }

    const elements = getElementNodes()

    elements.forEach((el) => {
      el.addEventListener('mouseenter', handleMouseEnter)
    })

    return () => {
      elements.forEach((el) => {
        el.removeEventListener('mouseenter', handleMouseEnter)
      })
    }
  }, [getElementNodes])

  return (
    <Tooltip placement="top" label={TOOLTIP_TEXT}>
      <button
        className={styles.button}
        style={{
          top: buttonPosition.y,
          left: buttonPosition.x,
          width: buttonPosition.w,
        }}
      />
    </Tooltip>
  )
}
